import { render, staticRenderFns } from "./FacultyHours.vue?vue&type=template&id=654b5686&scoped=true"
import script from "./FacultyHours.vue?vue&type=script&lang=js"
export * from "./FacultyHours.vue?vue&type=script&lang=js"
import style0 from "./FacultyHours.vue?vue&type=style&index=0&id=654b5686&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654b5686",
  null
  
)

export default component.exports